import { orderBy } from "lodash";
import {
  E_101C_AI_MARRIAGE_TYPE,
  E_ALKHATTABAT_RATING_ANSWERS_IDS,
  E_KHATTABAT_APPLICATION_STATUS,
  E_TRANSFER_PACKAGE_TYPE,
  TDbRolloutPercentage,
  TReportCreatedFromType,
  TStatus
} from "../Types";
import {
  DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE,
  MAX_KHATTABA_ASSIGNEES,
  MIN_KHATTABA_ASSIGNEES,
  ONE_DAY_TOTAL_HOURS
} from "./core-constants";
import { T101CFilters, T101MFilters, TEt3PickerOption } from "../TypesNEW";

export const SEARCH_BY_INPUT_USER_ID = "userId";

export const CAMERA_SOLID = "camera-solid";

export const DEFAULT_ET3_PICKER_SINGLE_VALUE = { label: "", value: "" };

export const TRANSFER_PACKAGE_TYPE_OPTIONS: TEt3PickerOption[] = Object.values(
  E_TRANSFER_PACKAGE_TYPE
).map((packageType) => ({ label: packageType, value: packageType }));

export const SUPERVISOR_PERMISSIONS_OPTIONS = [
  { value: "0", label: "No Permission" },
  { value: "1", label: "Has Permission" }
];

export const AUDITOR_PROMOCODE_UPDATE = [
  { label: "Not Active", value: "0" },
  { label: "Active", value: "1" }
];

export const APPROVAL_LIMIT = [
  { label: "10", value: "10" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "250", value: "250" }
];

export const PENDING_REPORTS_LIMIT = [{ label: "5", value: 5 }];

export const NOT_PENDING_REPORTS_LIMIT = [
  { label: "5", value: "5" },
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "30", value: "30" },
  { label: "50", value: "50" },
  { label: "All", value: "150" }
];

export const EVENTS_LIMIT_REPORT = [{ label: "8", value: "8" }];

export const USER_SEARCH_FORM_LIMIT = [
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "250", value: "250" },
  { label: "500", value: "500" }
];

export const EVENTS_LIMIT = [
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "150", value: "150" },
  { label: "200", value: "200" },
  { label: "250", value: "250" },
  { label: "300", value: "300" }
];
//reports status
export const STATUS_PICKER_ENTRIES: { label: string; value: TStatus }[] = [
  { label: "Pending", value: "pending" },
  { label: "Resolved", value: "resolved" },
  { label: "Warning", value: "warning" },
  { label: "Banned", value: "banned" }
];

export const COUTRIES_GROUP_PICKER_ENTRIES: {
  label: string;
  value: TReportCreatedFromType;
}[] = [
  { label: "All", value: "all" },
  { label: "Indonesia/Malaysia", value: "indonesia_malaysia" },
  { label: "Other", value: "other" }
];

//for register activities
export const COUNTRY_PICKER_ENTRIES = [
  { label: "All Countries", value: "all" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Egypt", value: "EG" },
  { label: "Lebanon", value: "LB" },
  { label: "Tunisia", value: "TN" },
  { label: "Morocco", value: "MA" },
  { label: "Jordan", value: "JO" },
  { label: "Algeria", value: "ADZ" },
  { label: "Arab Emirates", value: "AE" },
  { label: "Syria", value: "SY" },
  { label: "Iraq", value: "IQ" },
  { label: "Bahrein", value: "BH" }
];

export const PLATFORM_PICKER_ENTRIES = [
  { label: "All", value: "all" },
  { label: "Android", value: "android" },
  { label: "Ios", value: "ios" }
];

export const TIMEFRAME_PICKER_ENTRIES = [
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" }
];

//userAdvancedPage
export const USER_SEARCH_TYPE = [
  { label: "Option", value: "option_search" },
  { label: "Criteria", value: "criteria_search" }
];

//webPaymentPage
export const WEB_PAYMENT_SEARCH_TYPE = [
  { label: "user ID", value: "BY_USER_ID" },
  { label: "Date", value: "BY_DATE" },
  { label: "Email", value: "BY_EMAIL" },
  { label: "Transaction ID", value: "BY_TRANSACTION_ID" }
];

export const USER_SEARCH_BY_ENTRIES = [
  { label: "User ID", value: "userId" },
  { label: "Profile ID", value: "profileId" },
  { label: "Username", value: "username" },
  { label: "Email", value: "email" },
  { label: "Device ID", value: "deviceId" },
  { label: "Phone Number", value: "phoneNumber" },
  { label: "Referral Code", value: "referralCode" }
];

export const USER_SEARCH_BY_PLACEHOLDERS = {
  userId: "User ID(number)",
  profileId: "Profile ID",
  username: "Username(string)",
  email: "Correct Email",
  deviceId: "Device ID",
  phoneNumber: "number (should start with +)",
  referralCode: "Referral Code(string)"
};

export const USER_STATUS_ENTRIES = [
  { label: "Active", value: "active" },
  { label: "Deactivated", value: "deactivated" },
  { label: "Banned", value: "banned" },
  { label: "Temporary Ban", value: "temporary_banned" }
];

export const ORDER_PICKER_ENTRIES: { label: string; value: "ASC" | "DESC" }[] =
  [
    { label: "ASC", value: "ASC" },
    { label: "DESC", value: "DESC" }
  ];

// for has flag helper
export const FLAG_NATIONALITY_Moroccan_Tunisian_Lebanese = ["MA", "TN", "LB"];
export const FLAG_NATIONALITY_USA_Canadian = ["US", "CA"];
export const FLAG_NATIONALITY_UK_Egyptian_Syrian = ["GB", "EG", "SY"];
export const FLAG_RESIDENCE_Nigeria_Ghana_Kenya = ["NG", "GH", "KE"];

// for admin audit
export const ADMIN_AUDIT_EVENT_PICKER_ENTRIES = [
  { label: "All", value: "all" },
  { label: "Approve/Reject Description", value: "approval_description" },
  {
    label: "Approve/Reject Peer Description",
    value: "approval_peer_description"
  },
  { label: "Approve/Reject Pictures", value: "approval_picture" },
  { label: "Report", value: "report" },
  { label: "Investigation Cases", value: "investigation_cases" }
];

export const ADMIN_AUDIT_PICKER_ENTRIES = [
  {
    label: "Approve/Reject Description",
    value: "approval_description"
  },
  {
    label: "Approve/Reject Peer Description",
    value: "approval_peer_description"
  },
  { label: "Approve/Reject Pictures", value: "approval_picture" },
  { label: "Report", value: "report" },
  { label: "Investigation Cases", value: "investigation_cases" }
];
export const ADMIN_SUPERVISE_PICKER_ENTRIES = [
  { label: "All", value: "all" },
  {
    label: "Approve/Reject Description",
    value: "approval_description"
  },
  {
    label: "Approve/Reject Peer Description",
    value: "approval_peer_description"
  },
  { label: "Approve/Reject Pictures", value: "approval_picture" },
  { label: "Report", value: "report" },
  { label: "Investigation Cases", value: "investigation_cases" }
];

//for editdata activities
export const ALL_COUNTRY_PICKER_ENTRIES = orderBy(
  [
    { value: "AD", label: "Andorra Andorre أندورا" },
    {
      value: "AE",
      label: "United Arab Emirates Émirats Arabes Unis الإمارات العربية المتحدة"
    },
    { value: "AF", label: "Afghanistan Afghanistan أفغانستان" },
    {
      value: "AG",
      label: "Antigua And Barbuda Antigua-et-Barbuda أنتيغوا وبربودا"
    },
    { value: "AI", label: "Anguilla Anguilla أنغويلا" },
    { value: "AL", label: "Albania Albanie ألبانيا" },
    { value: "AM", label: "Armenia Arménie أرمينيا" },
    { value: "AO", label: "Angola Angola أنغولا" },
    { value: "AQ", label: "Antarctica Antarctique أنتاركتيكا" },
    { value: "AR", label: "Argentina Argentine الأرجنتين" },
    {
      value: "AS",
      label: "American Samoa Samoa américaines ساموا-الأمريكي"
    },
    { value: "AT", label: "Austria L'Autriche النمسا" },
    { value: "AU", label: "Australia Australie أستراليا" },
    { value: "AW", label: "Aruba Aruba أروبا" },
    { value: "AZ", label: "Azerbaijan Azerbaïdjan أذربيجان" },
    {
      value: "BA",
      label: "Bosnia And Herzegovina La Bosnie-Herzégovine البوسنة و الهرسك"
    },
    { value: "BB", label: "Barbados Barbade بربادوس" },
    { value: "BD", label: "Bangladesh Bangladesh بنغلاديش" },
    { value: "BE", label: "Belgium Belgique بلجيكا" },
    { value: "BF", label: "Burkina Faso Burkina Faso بوركينا فاسو" },
    { value: "BG", label: "Bulgaria Bulgarie بلغاريا" },
    { value: "BH", label: "Bahrain Bahreïn البحرين" },
    { value: "BI", label: "Burundi Burundi بوروندي" },
    { value: "BJ", label: "Benin Bénin بنين" },
    { value: "BM", label: "Bermuda Iles des Bermudes جزر برمود" },
    { value: "BN", label: "Brunei Brunei بروناي" },
    { value: "BO", label: "Bolivia Bolivie بوليفيا" },
    { value: "BR", label: "Brazil Brésil البرازيل" },
    { value: "BS", label: "Bahamas Bahamas الباهاماس" },
    { value: "BT", label: "Bhutan Bhoutan بوتان" },
    { value: "BW", label: "Botswana Botswana بوتسوانا" },
    { value: "BY", label: "Belarus Biélorussie روسيا البيضاء" },
    { value: "BZ", label: "Belize Belize بيليز" },
    { value: "CA", label: "Canada Canada كندا" },
    {
      value: "CD",
      label:
        "Democratic Republic of Congo République Démocratique du Congo جمهورية الكونغو الديمقراطية"
    },
    {
      value: "CF",
      label:
        "Central African Republic République centrafricaine جمهورية أفريقيا الوسطى"
    },
    { value: "CG", label: "Congo Congo الكونغو" },
    { value: "CH", label: "Switzerland Suisse سويسرا" },
    { value: "CI", label: "Ivory Coast Côte d'Ivoire ساحل العاج" },
    { value: "CK", label: "Cook Islands Îles Cook جزر كوك" },
    { value: "CL", label: "Chile Chili تشيلي" },
    { value: "CM", label: "Cameroon Cameron كاميرون" },
    { value: "CN", label: "China Chine صين" },
    { value: "CO", label: "Colombia Colombie كولومبيا" },
    { value: "CR", label: "Costa Rica Costa Rica كوستاريكا" },
    { value: "CU", label: "Cuba Cuba كوبا" },
    { value: "CV", label: "Cape Verde Cape Verde الرأس الأخضر" },
    { value: "CY", label: "Cyprus Chypre قبرص" },
    {
      value: "CZ",
      label: "Czech Republic République Tchèque الجمهورية التشيكية"
    },
    { value: "DE", label: "Germany Allemagne ألمانيا" },
    { value: "DJ", label: "Djibouti Djibouti جيبوتي" },
    { value: "DK", label: "Denmark Danemark الدانمارك" },
    { value: "DM", label: "Dominica Dominique دومينيكا" },
    {
      value: "DO",
      label: "Dominican Republic République Dominicaine الجمهورية الدومينيكية"
    },
    { value: "DZ", label: "Algeria Algérie الجزائر" },
    { value: "EC", label: "Ecuador Equateur إكوادور" },
    { value: "EE", label: "Estonia Estonie استونيا" },
    { value: "EG", label: "Egypt Egypte مصر" },
    {
      value: "EH",
      label: "Western Sahara Sahara occidentale الصحراء الغربية"
    },
    { value: "ER", label: "Eritrea Érythrée إريتريا" },
    { value: "ES", label: "Spain Espagne إسبانيا" },
    { value: "ET", label: "Ethiopia Ethiopie أثيوبيا" },
    { value: "FI", label: "Finland Finlande فنلندا" },
    { value: "FJ", label: "Fiji Fidji فيجي" },
    { value: "FO", label: "Faroe Islands Îles Féroé جزر فارو" },
    { value: "FR", label: "France France فرنسا" },
    { value: "GA", label: "Gabon Gabon الغابون" },
    { value: "GB", label: "United Kingdom Royaume-Uni المملكة المتحدة" },
    { value: "GD", label: "Grenada Grenade غرينادا" },
    { value: "GE", label: "Georgia Géorgie جيورجيا" },
    {
      value: "GF",
      label: "French Guiana Guyane Française غويانا الفرنسية"
    },
    { value: "GH", label: "Ghana Ghana غانا" },
    { value: "GL", label: "Greenland Greenland جرينلاند" },
    { value: "GM", label: "Gambia Gambie غامبيا" },
    { value: "GN", label: "Guinea Guinée غينيا" },
    { value: "GP", label: "Guadeloupe Guadeloupe جوادلوب" },
    {
      value: "GQ",
      label: "Equatorial Guinea Guinée Équatoriale غينيا الاستوائي"
    },
    { value: "GR", label: "Greece Grèce اليونان" },
    { value: "GT", label: "Guatemala Guatemala غواتيمال" },
    { value: "GU", label: "Guam Guam جوام" },
    { value: "GW", label: "Guinea-Bissau Guinée-Bissau غينيا-بيساو" },
    { value: "GY", label: "Guyana Guyane غيانا" },
    { value: "HK", label: "Hong Kong Hong Kong هونغ كونغ" },
    { value: "HN", label: "Honduras Honduras هندوراس" },
    { value: "HR", label: "Croatia Croatie كرواتيا" },
    { value: "HT", label: "Haiti Haïti هايتي" },
    { value: "HU", label: "Hungary Hongrie المجر" },
    { value: "ID", label: "Indonesia Indonésie أندونيسيا" },
    { value: "IE", label: "Ireland Irlande أيرلندا" },
    { value: "PS", label: "Palestine Palestine فلسطين" },
    { value: "IN", label: "India Inde الهند" },
    { value: "IQ", label: "Iraq Irak العراق" },
    { value: "IR", label: "Iran Iran إيران" },
    { value: "IS", label: "Iceland Islande آيسلندا" },
    { value: "IT", label: "Italy Italie إيطاليا" },
    { value: "JM", label: "Jamaica Jamaïque جمايكا" },
    { value: "JO", label: "Jordan Jordan الأردن" },
    { value: "JP", label: "Japan Japon اليابان" },
    { value: "KE", label: "Kenya Kenya كينيا" },
    { value: "KG", label: "Kyrgyzstan Kirghizistan قيرغيزستان" },
    { value: "KH", label: "Cambodia Cambodge كمبوديا" },
    { value: "KI", label: "Kiribati Kiribati كيريباتي" },
    { value: "KM", label: "Comoros Comores جزر القمر" },
    {
      value: "KN",
      label: "Saint Kitts And Nevis Saint-Christophe-et-Niévès سانت كيتس ونيفس"
    },
    { value: "KP", label: "North Korea Corée du Nord كوريا الشماليه" },
    { value: "KR", label: "South Korea Corée du Sud كوريا الجنوبية" },
    { value: "KW", label: "Kuwait Koweit الكويت" },
    { value: "KY", label: "Cayman Islands Îles Caïmans جزر كايمان" },
    { value: "KZ", label: "Kazakhstan Kazakhstan كازاخستان" },
    { value: "LA", label: "Laos Laos لاوس" },
    { value: "LB", label: "Lebanon Liban لبنان" },
    { value: "LC", label: "Saint Lucia Sainte-Lucie سانت لوسيا" },
    { value: "LI", label: "Liechtenstein Liechtenstein ليختنشتين" },
    { value: "LK", label: "Sri Lanka Sri Lanka سريلانكا" },
    { value: "LR", label: "Liberia Libéria ليبيريا" },
    { value: "LS", label: "Lesotho Lesotho ليسوتو" },
    { value: "LT", label: "Lithuania Lituanie لتوانيا" },
    { value: "LU", label: "Luxembourg Luxembourg لوكسمبورغ" },
    { value: "LV", label: "Latvia Lettonie لاتفيا" },
    { value: "LY", label: "Libya Libye ليبيا" },
    { value: "MA", label: "Morocco Maroc المغرب" },
    { value: "MC", label: "Monaco Monaco موناكو" },
    { value: "MD", label: "Moldova Moldavie مولدافيا" },
    { value: "ME", label: "Montenegro Montenegro الجبل الأسو" },
    { value: "MG", label: "Madagascar Madagascar مدغشقر" },
    { value: "MH", label: "Marshall Islands Iles Marshall جزر مارشال" },
    { value: "MK", label: "Macedonia Macédoine مقدونيا" },
    { value: "ML", label: "Mali Mali مالي" },
    { value: "MM", label: "Myanmar Myanmar ميانمار" },
    { value: "MN", label: "Mongolia Mongolie منغوليا" },
    { value: "MO", label: "Macao Macao ماكاو" },
    {
      value: "MP",
      label:
        "Northern Mariana Islands Îles Mariannes du Nord جزر ماريانا الشمالية"
    },
    { value: "MQ", label: "Martinique Martinique مارتينيك" },
    { value: "MR", label: "Mauritania Mauritanie موريتانيا" },
    { value: "MS", label: "Montserrat Montserrat مونتسيرات" },
    { value: "MT", label: "Malta Malte مالطا" },
    { value: "MU", label: "Mauritius Ile Maurice موريشيوس" },
    { value: "MV", label: "Maldives Maldives المالديف" },
    { value: "MW", label: "Malawi Malawi مالاوي" },
    { value: "MX", label: "Mexico Mexique المكسيك" },
    { value: "MY", label: "Malaysia Malaisie ماليزيا" },
    { value: "MZ", label: "Mozambique Mozambique موزمبيق" },
    { value: "NA", label: "Namibia Namibie ناميبيا" },
    {
      value: "NC",
      label: "New Caledonia Nouvelle Calédonie كاليدونيا الجديدة"
    },
    { value: "NE", label: "Niger Niger النيجر" },
    { value: "NG", label: "Nigeria Nigeria نيجيريا" },
    { value: "NI", label: "Nicaragua Nicaragua نيكاراجوا" },
    { value: "NL", label: "Netherlands Hollande هولندا" },
    { value: "NO", label: "Norway Norvège النرويج" },
    { value: "NP", label: "Nepal Népal نيبال" },
    { value: "NR", label: "Nauru Nauru ناورو" },
    { value: "NU", label: "Niue Niue نييوي" },
    { value: "NZ", label: "New Zealand Nouvelle-Zélande نيوزيلندا" },
    { value: "OM", label: "Oman Oman عُمان" },
    { value: "PA", label: "Panama Panama بنما" },
    { value: "PE", label: "Peru Pérou بيرو" },
    {
      value: "PF",
      label: "French Polynesia Polynésie française بولينيزيا الفرنسية"
    },
    {
      value: "PG",
      label: "Papua New Guinea Papouasie Nouvelle Guinée بابوا غينيا الجديدة"
    },
    { value: "PH", label: "Philippines Philippines الفليبين" },
    { value: "PK", label: "Pakistan Pakistan باكستان" },
    { value: "PL", label: "Poland Pologne بولندا" },
    { value: "PR", label: "Puerto Rico Porto Rico بورتوريكو" },
    { value: "PT", label: "Portugal le Portugal البرتغال" },
    { value: "PW", label: "Palau Palau بالاو" },
    { value: "PY", label: "Paraguay Paraguay باراغواي" },
    { value: "QA", label: "Qatar Qatar قطر" },
    { value: "RO", label: "Romania Roumanie رومانيا" },
    { value: "RS", label: "Serbia République de Serbie جمهورية صربيا" },
    { value: "RU", label: "Russian Federation Russie روسيا" },
    { value: "RW", label: "Rwanda Rwanda رواندا" },
    {
      value: "SA",
      label: "Saudi Arabia Arabie Saoudite المملكة العربية السعودية"
    },
    { value: "SB", label: "Solomon Islands îles Salomon جزر سليمان" },
    { value: "SC", label: "Seychelles Seychelles سيشيل" },
    { value: "SD", label: "Sudan Soudan السودان" },
    { value: "SE", label: "Sweden Suède السويد" },
    { value: "SG", label: "Singapore Singapour سنغافورة" },
    { value: "SI", label: "Slovenia Slovénie سلوفينيا" },
    { value: "SK", label: "Slovakia Slovaquie سلوفاكيا" },
    { value: "SL", label: "Sierra Leone Sierra Leone سيراليون" },
    { value: "SM", label: "San Marino Saint Marin سان مارينو" },
    { value: "SN", label: "Senegal Sénégal السنغال" },
    { value: "SO", label: "Somalia Somalie الصومال" },
    { value: "SR", label: "Surilabel Surilabel سورينام" },
    { value: "SV", label: "El Salvador Salvador إلسلفادور" },
    { value: "SY", label: "Syria Syrie سوريا" },
    { value: "SZ", label: "Swaziland Swaziland سوازيلند" },
    { value: "TD", label: "Chad Tchad تشاد" },
    { value: "TG", label: "Togo Togo توغو" },
    { value: "TH", label: "Thailand Thaïlande تايلندا" },
    { value: "TJ", label: "Tajikistan Tadjikistan طاجيكستان" },
    { value: "TM", label: "Turkmenistan Turkménistan تركمانستان" },
    { value: "TN", label: "Tunisia Tunisie تونس" },
    { value: "TO", label: "Tonga Tonga تونغا" },
    { value: "TR", label: "Turkey Turquie تركيا" },
    {
      value: "TT",
      label: "Trinidad And Tobago Trinité-et-Tobago ترينيداد وتوباغو"
    },
    { value: "TV", label: "Tuvalu Tuvalu توفالو" },
    { value: "TZ", label: "Tanzania Tanzanie تنزانيا" },
    { value: "UA", label: "Ukraine Ukraine أوكرانيا" },
    { value: "UG", label: "Uganda Ouganda أوغندا" },
    { value: "US", label: "United States États-Unis الولايات المتحدة" },
    { value: "UY", label: "Uruguay Uruguay أورغواي" },
    { value: "UZ", label: "Uzbekistan Ouzbékistan أوزباكستان" },
    {
      value: "VC",
      label:
        "Saint Vincent And The Grenadines Saint-Vincent-et-les-Grenadines سانت فنسنت وجزر غرينادين"
    },
    { value: "VE", label: "Venezuela Venezuela فنزويلا" },
    { value: "VN", label: "Vietnam Vietnam فيتنام" },
    { value: "VU", label: "Vanuatu Vanuatu فانواتو" },
    { value: "WS", label: "Samoa Samoa ساموا" },
    { value: "YE", label: "Yemen Yemen اليمن" },
    { value: "ZA", label: "South Africa Afrique du Sud جنوب أفريقيا" },
    { value: "ZM", label: "Zambia Zambie زامبيا" },
    { value: "ZW", label: "Zimbabwe Zimbabwe زمبابوي" },
    { value: "VA", label: "Vatican Vatican الفاتيكان" }
  ],
  ["name"],
  ["asc"]
);

//for edit data activities
export const ALL_MARITAL_STATUS_MALE = [
  { value: "single", label: "أعزب, Single, Célibataire" },
  {
    value: "divorce",
    label: " مطلق من دون أطفال, Divorced without kids,  Divorcé sans enfants"
  },
  {
    value: "divorce_with_children",
    label: "مطلق مع أطفال, Divorced with kids, Divorcé avec enfant(s)"
  },

  {
    value: "widower",
    label: "أرمل من دون أطفال , Widower without kids ,Veuf sans enfants"
  },
  {
    value: "widower_with_children",
    label: "أرمل مع أطفال ,Widower with kid(s) ,Veuf avec enfant(s)"
  },

  { value: "married", label: "متزوج ,Married, Marié" }
];

export const ALL_MARITAL_STATUS_FEMALE = [
  { value: "single", label: "أعزب, Single, Célibataire" },
  {
    value: "divorce",
    label: " مطلق من دون أطفال, Divorced without kids,  Divorcé sans enfants"
  },
  {
    value: "divorce_with_children",
    label: "مطلق مع أطفال, Divorced with kids, Divorcé avec enfant(s)"
  },

  {
    value: "widower",
    label: "أرمل من دون أطفال , Widower without kids ,Veuf sans enfants"
  },
  {
    value: "widower_with_children",
    label: "أرمل مع أطفال ,Widower with kid(s) ,Veuf avec enfant(s)"
  }
];

export const EDUCATION_ENTRIES = [
  { value: "1", label: "	تعليم أساسي,	Less than High School,	Collège" },
  { value: "2", label: "	تعليم متوسط/ معهد,	High School,	Lycée" },
  { value: "3", label: "	شهادة جامعية ,	Bachelor,	License" },
  { value: "5", label: "	ماجستير ,	Master,	Master" },
  { value: "6", label: "	دكتوراه ,	PHD,	Doctorat" }
];

export const WORK_ENTRIES = [
  { value: "1", label: " طالب ,	A student,	Étudiant" },
  { value: "2", label: " موظف ,	An employee,	Employé" },
  { value: "7", label: "موظف برتبة, عالية,	A senior employee,	Employé Senior" },
  { value: "3", label: " مدير,	A manager / director,	Manager / Directeur" },
  { value: "4", label: "عاطل عن العمل,	Unemployed,	Sans emploi" },
  { value: "5", label: " متقاعد,	Retired	,Retraité" },
  {
    value: "-1",
    label: " أفضل عدم الإجابة,	I prefer not to answer	,Je préfère ne pas répondre"
  }
];

export const DATE_RANGE = [
  { label: "3 Months", value: "3" },
  { label: "6 Months", value: "6" },
  { label: "9 Months", value: "9" },
  { label: "12 Months", value: "12" },
  { label: "All Time", value: "-1" }
];

export const BLOCKED_REQUESTS_LIMIT = [
  { label: "5", value: "5" },
  { label: "100", value: "100" },
  { label: "500", value: "500" },
  { label: "1000", value: "1000" },
  { label: "1500", value: "1500" }
];

export const USER_SEARCH_BY_ENTRIES_FOR_REFERRAL_CODE_USAGE_PAGE = [
  { label: "User ID", value: "userId" },
  { label: "ReferralCode", value: "referralCode" }
];

export const USER_SEARCH_BY_PLACEHOLDERS_FOR_REFERRAL_CODE_USAGE = {
  userId: "User ID(number)",
  referralCode: "Referral Code(string)"
};

export const REFERRAL_CODE_USAGE_LIMIT = [
  { label: "10", value: "10" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "250", value: "250" }
];
export const STATS_LIMIT = [
  { label: "10", value: "10" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "250", value: "250" },
  { label: "500", value: "500" }
];


export const REFERRAL_CODE_INITIAL_SELECTED_LIMIT = {
  label: "10",
  value: "10"
};

export const PAYMENT_LIMIT = [
  { label: "5", value: "5" },
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "30", value: "30" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "150", value: "150" },
  { label: "200", value: "200" },
  { label: "All", value: "500" }
];

export const PROMOCODE_LIMIT = [
  { label: "10", value: "10" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "500", value: "500" }
];

export const ACCOUNTS_DELETION_DATA_LIMIT = [
  { label: "10", value: "10" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "250", value: "250" }
];

export const USER_MESSAGES_TYPE = [
  { label: "all", value: "all" },
  { label: "text", value: "text" },
  { label: "sticker", value: "sticker" },
  { label: "khotabe message", value: "khotabe_message" },
  { label: "voice", value: "voice" },
  { label: "picture", value: "picture" }
];

export const TEMPORARY_BAN_DAYS = [
  { label: 1, value: 1 },
  { label: 3, value: 3 },
  { label: 5, value: 5 },
  { label: 7, value: 7 }
];

export const RATE_US_LIMIT = [
  { label: "50 days", value: "50" },
  { label: "100 days", value: "100" },
  { label: "200 days", value: "200" },
  { label: "300 days", value: "300" }
];

export const QA_IOS_RECEIPT_TOKENS_LIMIT = [
  {
    label: "100",
    value: "100"
  }
];

export const KHATTABAT_MATCHING_RESULTS_LIMIT = [
  { label: "10", value: "10" },
  { label: "25", value: "25" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "250", value: "250" }
];

export const KHATTABAT_MATCHING_RESULTS_MATCH_APP_LANGUAGE = [
  { label: "Arabic", value: "AR" },
  { label: "English", value: "ENG" },
  { label: "Frensh", value: "FR" },
  { label: "Turkish", value: "TR" },
  { label: "Indonesian", value: "IND" }
];
export const CSR_TIME_SHIFT = () => {
  let times: string[] = [];
  for (let i = 0; i < ONE_DAY_TOTAL_HOURS; i++) {
    const finalizedStringIndex = i < 10 ? `0${i}` : `${i}`;
    times.push(`${finalizedStringIndex}:00`);
  }
  return times;
};

export const ONE_O_ONE_C_FILTER: { label: string; value: T101CFilters }[] = [
  { label: "", value: "none" },
  { label: "Unread Messages", value: "unread_messages" },
  { label: "No 102", value: "no_one_o_two" },
  { label: "Renewed", value: "renewed" },
  { label: "Expired", value: "expired" }
];

export const ONE_O_ONE_M_FILTER: { label: string; value: T101MFilters }[] = [
  { label: "Unread Messages", value: "unread_messages" },
  { label: "Recent Login", value: "recent_login" },
  { label: "Highlighted", value: "highlighted" }
];

//user quiz questions

export const TYPE_OF_MARIAGE = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Official - Religious", value: "1" },
  { label: "Polygamous", value: "2" },
  { label: "Civil", value: "5" },
  { label: "Misyar", value: "7" }
];

export const MARITAL_STATUS_FEMALE = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Divorced without kids", value: "divorce" },
  { label: "Divorced with kid(s)", value: "divorce_with_children" },
  { label: "Single", value: "single" },
  { label: "Widow without kids", value: "widower" },
  { label: "Widow with kid(s)", value: "widower_with_children" }
];

export const MARITAL_STATUS_MALE = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Divorced without kids", value: "divorce" },
  { label: "Divorced with kid(s)", value: "divorce_with_children" },
  { label: "Married", value: "married" },
  { label: "Single", value: "single" },
  { label: "Widower without kids", value: "widower" },
  { label: "Widower with kid(s)", value: "widower_with_children" }
];

export const EDUCATION_LEVEL = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Less than High School", value: "1" },
  { label: "High School", value: "2" },
  { label: "Bachelor", value: "3" },
  { label: "Master", value: "5" },
  { label: "PhD", value: "6" }
];

export const WORK_LEVEL = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "I prefer not to answer", value: "-1" },
  { label: "A student", value: "1" },
  { label: "An employee", value: "2" },
  { label: "A manager / director", value: "3" },
  { label: "Unemployed", value: "4" },
  { label: "Retired", value: "5" },
  { label: "A senior employee", value: "7" }
];

export const SMOKING_LEVEL = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Yes", value: "1" },
  { label: "Occasionally", value: "2" },
  { label: "No", value: "3" }
];

export const HAVING_KIDS = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "As soon as possible", value: "1" },
  { label: "Not before a couple of years", value: "2" },
  { label: "Depends on the situation", value: "3" },
  { label: "Never", value: "4" }
];

export const FEMALE_WORK_STUDY = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "No", value: "1" },
  { label: "Yes", value: "2" },
  { label: "Depends on the situation", value: "3" },
  { label: "Yes, but from home", value: "4" }
];

export const BELONG_TO_A_TRIBE = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "No", value: "0" },
  { label: "Yes", value: "1" }
];

export const RELOCATION = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Yes, if close to where I am now", value: "1" },
  { label: "Yes, within my country", value: "2" },
  { label: "Yes", value: "3" },
  { label: "No", value: "4" }
];

export const SKIN_COLOR = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "White", value: "1" },
  { label: "Wheatish light", value: "2" },
  { label: "Wheatish", value: "3" },
  { label: "Bronze", value: "4" },
  { label: "Light black", value: "5" },
  { label: "Dark black", value: "6" }
];

export const VEIL = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "No veil", value: "1" },
  { label: "A veil", value: "2" },
  { label: "A burka, niqab or khimar", value: "3" },
  { label: "Jilbab", value: "4" }
];

export const RELIGION = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Muslim", value: "muslim_other" },
  { label: "Muslim sunnite", value: "muslim_sunnite" },
  { label: "Muslim shiite", value: "muslim_shiite" },
  { label: "Other", value: "other_other" }
];

export const INCOME = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "High", value: "1" },
  { label: "Medium", value: "2" },
  { label: "Low", value: "3" },
  { label: "No income", value: "4" }
];

export const KHATTABA_REASSIGN_TYPE = [
  { label: "all", value: "all" },
  { label: "one", value: "one" }
];

export const SUBSCRIPTION_OPTIONS = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Paid", value: "paid" },
  { label: "Was paying", value: "was_paying" },
  { label: "Not paid", value: "not_paid" }
];

export const GENDER_OPTIONS = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Female", value: "f" },
  { label: "Male", value: "m" }
];

export const ACTION_TAKEN_OPTIONS = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Warn", value: "warn" },
  { label: "Temporary banned", value: "temporary_banned" },
  { label: "Banned", value: "banned" },
  { label: "Resolved", value: "resolved" }
];

export const KHATTABAT_CAPACITY_PICKER_OPTIONS = () => {
  let result: { label: string; value: string }[] = [];

  for (let i = MIN_KHATTABA_ASSIGNEES; i <= MAX_KHATTABA_ASSIGNEES; i++) {
    result.push({ label: `${i}`, value: `${i}` });
  }
  return result;
};

export const FEATURE_ROLLOUT_PICKER_OPTIONS = (): {
  label: string;
  value: TDbRolloutPercentage;
}[] => {
  const percentages: TDbRolloutPercentage[] = [
    "10",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
    "80",
    "90",
    "100"
  ];

  return percentages.map((p) => ({ label: p, value: p }));
};

export const ONE_O_ONE_C_AI_STATUS_FILTER: {
  label: string;
  value: string;
}[] = [
  DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE,
  { label: "Pending", value: E_KHATTABAT_APPLICATION_STATUS.PENDING },
  { label: "Approved", value: E_KHATTABAT_APPLICATION_STATUS.APPROVED },
  { label: "Rejected", value: E_KHATTABAT_APPLICATION_STATUS.REJECTED },
  { label: "Incomplete", value: E_KHATTABAT_APPLICATION_STATUS.INCOMPLETE }
];

export const ONE_O_ONE_C_AI_STATS_FILTER: {
  label: string;
  value: string;
}[] = [
  {
    label: "Rated Very Helpful",
    value: `rating-${E_ALKHATTABAT_RATING_ANSWERS_IDS.VERY_HELPFUL}`
  },
  {
    label: "Rated Helpful",
    value: `rating-${E_ALKHATTABAT_RATING_ANSWERS_IDS.HELPFUL}`
  },
  {
    label: "Rated Not Helpful",
    value: `rating-${E_ALKHATTABAT_RATING_ANSWERS_IDS.BAD}`
  },
  { label: "Misyar", value: `marriage-${E_101C_AI_MARRIAGE_TYPE.MISYAR}` },
  { label: "Regular", value: `marriage-${E_101C_AI_MARRIAGE_TYPE.REGULAR}` },
  {
    label: "Polygamous",
    value: `marriage-${E_101C_AI_MARRIAGE_TYPE.POLYGAMOUS}`
  },
  { label: "All breach", value: E_KHATTABAT_APPLICATION_STATUS.BREACH }
];
